import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Button from '@/app/_components/buttons/Button';

interface Props {
  step: string;
  hasNext: boolean;
  onNext: () => void;
}

const OnboardingMajor = ({ step, hasNext, onNext }: Props) => {
  const { register, control, watch } = useFormContext();

  const watchMajor = watch('major', false);

  if (step !== 'MAJOR') {
    return null;
  }

  return (
    <div className="w-full md:w-[430px]">
      <label className="text-white font-hanken text-4xl font-extrabold mb-8 block">
        What’s your major?
      </label>

      <Controller
        control={control}
        name="major"
        rules={{ required: true }}
        render={({ field: { value } }) => {
          return (
            <div className="relative z-0 w-full mb-5 floating-labels">
              <input
                data-test-id="major-input"
                className="pt-3 pb-2 block w-full px-0 mt-0 bg-transparent border-0 border-b opacity-70 border-white appearance-none focus:outline-none focus:ring-0 focus:opacity-100"
                type="text"
                {...register('major')}
                placeholder=" "
                required={true}
                value={value}
                aria-label="Enter your major"
              />
              <label
                htmlFor="major"
                className="absolute duration-300 top-3 -z-1 origin-0 text-white opacity-70 text-sm font-normal"
              >
                Enter your major
              </label>
            </div>
          );
        }}
      />
      {hasNext && (
        <Button
          data-test-id="onboarding-next"
          className="!rounded-full min-w-[200px] my-8"
          variant="primary"
          type="button"
          label="Next"
          disabled={!watchMajor || watchMajor.length <= 0}
          onClick={onNext}
        />
      )}
    </div>
  );
};

export default OnboardingMajor;
